import {
  FETCH_WAREHOUSE_LOGS,
  WAREHOUSE_LOGS_CLEAR,
  WAREHOUSE_LOGS_SET_PERIOD,
  WAREHOUSE_LOGS_SET_FILTER,
  WAREHOUSE_LOGS_CHANGE_ORDER,
  FETCH_WAREHOUSE_LOGS_FAILED,
  FETCH_WAREHOUSE_LOGS_STARTED,
  WAREHOUSE_LOGS_PAGINATED_CHANGE_PAGE
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  logs: [],
  page: 1,
  itemsPerPage: 50,
  status: statuses.idle,
  order: 'desc',
  pages: 0,
  filter: null,
  error: [],
  period: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_WAREHOUSE_LOGS_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case FETCH_WAREHOUSE_LOGS:
      return {
        ...state,
        logs: action.payload,
        status: statuses.succeeded,
        pages: Math.ceil(action.totalCount / state.itemsPerPage),
        totalCount: action.totalCount
      };
    case FETCH_WAREHOUSE_LOGS_FAILED:
      return { ...state, status: statuses.failed, logs: [], error: action.error };
    case WAREHOUSE_LOGS_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case WAREHOUSE_LOGS_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case WAREHOUSE_LOGS_SET_FILTER:
      return { ...state, filter: action.payload };
    case WAREHOUSE_LOGS_SET_PERIOD:
      return { ...state, period: action.payload };
    case WAREHOUSE_LOGS_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
